import React from 'react';
import parse from 'html-react-parser';
import LazyImage from '../LazyImage';
import './style.css';
import RenderContent from '../RenderContent';

const TextDisplay = ({ textString }) => {
    textString = '<p>' + (textString ? textString.replaceAll('\n', '</p><p>') : '') + '</p>';

    return (
        <div className="description">
            <RenderContent htmlString={textString}></RenderContent>
        </div>
    );
};

export default TextDisplay;
